import { Pipe, PipeTransform } from '@angular/core';
import { TimezoneService } from '@app/shared/services/timezone.service';

@Pipe({
  name: 'locTime'
})
export class LocTimePipe implements PipeTransform {
  constructor(private timezoneService: TimezoneService) {}

  transform(value: any): any {
    return new Date(Date.parse(value) + +localStorage.getItem('timezone') * 1000);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/loc-time.pipe.ts